<template lang="pug">
  router-link(
    :to="route"
    @mouseover.native="hover"
    @mouseleave.native="blur"
  )
    .product-teaser(:style="style" ref="container")
      .card-teaser.grid.rounded(v-if="display === 'card'" :class="{ hover: mouseover }")
        //- :style="{ 'background-image': `url(${image.loading})` }"
        figure.rounded.rounded-b-none.overflow-hidden(v-if="image && loaded && error === false")
          img(
            v-lazy="image"
            :title="teaser.name"
            :style="{ width: `${image.width}px`, height: `${image.height}px` }"
          )
          .background(:style="{ 'background-image': `url(${image.loading})` }")
        //- TODO: video
        .placeholder.rounded.rounded-b-none(v-else)
          svg(v-if="loading === false")
            line(x1="0" y1="100%" x2="100%" y2="0")
            line(x1="0" y1="0" x2="100%" y2="100%")
        .info.flex.flex-col.px-4.py-2
          .name.text-lg.primary-color(v-line-clamp:18="1") {{ teaser.name }}
          .description.text-xs(v-if="teaser.description" v-line-clamp:12="clamp")
            p.content(v-html="striptags(teaser.description)")
          .properties(v-if="properties.length")
            TeaserProperty(v-for="property in properties" :property="property" :key="property.key")
          .price.text-lg.text-right.font-normal
            //- nobr.secondary-color {{ price }}
            nobr.secondary-color(:class="{ strikethrough: salePrice }") {{ price }}
            nobr.sale(v-if="salePrice") {{ salePrice }}
      //- .rating(v-if="ratings && ratings.length")
      //-   StarRating(
      //-     :rating="rating"
      //-     :increment="0.1"
      //-     :read-only="true"
      //-     :show-rating="false"
      //-     :max-rating="stars"
      //-     :star-size="16"
      //-     :inline="true"
      //-   )
      //-   // .average {{ rating }}
      //-   // .raters ({{ ratings.length }})
      //-   .comments(v-if="comments.length")
      //-     span {{ comments.length }}
      //-     i.far.fa-comment
      //- p.category.is-uppercase.has-text-primary.has-text-weight-bold(v-if="category")
      //-     | {{ category }}
      //- h3.is-size-4(v-if="name" v-line-clamp:31="1")
      //-     | {{ name }}
      //- .bait
      //-     div(v-if="description" v-line-clamp:24="clamp")
      //-       p.content(v-html="striptags(description)")
      //- .bottom-line
      //-     .op
      //-         template(v-if="op")
      //-             | von
      //-             span {{ op }}
      //-     .link
      //-         router-link(:to="route") mehr ...
      .row-teaser(v-else-if="display === 'row'" :class="{ hover: mouseover }")
        //- TODO
      .tile-teaser.rounded(v-else :class="{ hover: mouseover }")
        figure.rounded.rounded-b-none(v-if="image && loaded && error === false" :style="{ height: `${image.height}px` }")
          img.rounded.rounded-b-none(
            v-lazy="image"
            :title="teaser.name"
            :style="{ width: `${image.width}px`, height: `${image.height}px` }"
          )
        //- TODO: video
        .placeholder.rounded.rounded-b-none(v-else-if="loading === false")
          svg(v-if="loading === false")
            line(x1="0" y1="100%" x2="100%" y2="0")
            line(x1="0" y1="0" x2="100%" y2="100%")
        .info.rounded.rounded-t-none.px-4.py-2
          .name.text-lg.primary-color(v-line-clamp:18="mouseover ? 3 : 1") {{ teaser.name }}
          transition(name="slide-fade")
            template(v-if="mouseover")
              .hidden-info
                .description.text-xs(v-if="teaser.description" v-line-clamp:12="12")
                  p.content(v-html="striptags(teaser.description)")
                .properties(v-if="properties.length")
                  TeaserProperty(v-for="property in properties" :property="property" :key="property.key")
          .price.text-lg.text-right.font-normal
            //- nobr.secondary-color {{ price }}
            nobr.secondary-color(:class="{ strikethrough: salePrice }") {{ price }}
            nobr.sale(v-if="salePrice") {{ salePrice }}
</template>

<script>
import { mapGetters } from 'vuex';
import striptags from 'striptags';
// import VanillaTilt from 'vanilla-tilt';

import { get, trim } from '@/helpers';
import { moneyFormat, formatTimestamp } from '@/filters';

import TeaserProperty from './TeaserProperty';

export default {
  name: 'Teaser',
  data() {
    return {
      delay: 150,
      mouseover: false,
      loaded: false,
      loading: true,
      error: false
      // stars: 5,
    };
  },
  props: {
    teaser: {
      type: Object,
      required: true
    },
    display: {
      type: String,
      default: 'card',
      validator: val => ['row', 'card', 'tile'].includes(val)
    }
  },
  components: {
    TeaserProperty
  },
  // watch: {
  //   image(image) {
  //     if (image?.src && this.loading) {
  //       this.preloadImage();
  //     }
  //   }
  // },
  computed: {
    route() {
      return {
        name: 'product-details',
        params: {
          product: this.teaser.slug
        }
      };
    },
    price() {
      const price = this.teaser.price;
      const customerGroup = price.customerGroup || get(this.cms, 'shop.defaultCustomerGroup');
      const code = get(customerGroup, 'currency.iso4217') || 'EUR';

      let value = price.value;
      if (this.customer && get(this.customer, 'show_net_prices')) value = price.net_value;

      return moneyFormat(value, code);
    },
    salePrice() {
      if (!this.teaser.salePrice) return null;

      const price = this.teaser.salePrice;
      const customerGroup = price.customerGroup || get(this.cms, 'shop.defaultCustomerGroup');
      const code = get(customerGroup, 'currency.iso4217') || 'EUR';

      let value = price.value;
      if (this.customer && get(this.customer, 'show_net_prices')) value = price.net_value;

      return moneyFormat(value, code);
    },
    properties() {
      const properties = [];
      const propertyPivots = this.teaser.propertyPivots || [];

      propertyPivots.forEach(propertyPivot => {
        if (propertyPivot.property.visible_on_product_listing === true) {
          const valueField = propertyPivot.property.propType.value_field;
          const values = propertyPivot.values.map(el => {
            let value = el[valueField];
            // date values are stored as unix timestamps and must be formatted
            if (valueField === 'date' && value) value = formatTimestamp(value);
            return {
              value,
              value_alt: el[propertyPivot.property.propType.value_field_alt]
            };
          });
          properties.push({
            key: propertyPivot.property.key,
            name: propertyPivot.property.name,
            type: propertyPivot.property.propType.key,
            values
          });
        }
      });

      return properties;
    },
    image() {
      let image;

      if (this.teaser.media && this.teaser.media.type === 'image' && this.teaser.media.image) {
        let data = this.teaser.media.image;

        const storageRoute = trim(
          `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
          '/'
        );

        let { method } = get(data, 'settings') || {};
        const { width, height } = data;
        let aspectRatio = width / height;

        const defaultWidth = get(this.teaser, 'style.width', 300);
        let w = Math.min(width, defaultWidth + 1);

        const defaultheight = get(this.teaser, 'style.height') ? this.teaser.style.height - 70 : 300;
        let h = Math.min(height, defaultheight + 1);

        if (aspectRatio > 1) {
          // landscape
          // limit by width
          h = w / aspectRatio;
        } else if (aspectRatio < 1) {
          // portrait
          // limit by height
          w = h * aspectRatio;
        }

        let fit = `fit&w=${w}&h=${h}`;

        if (method) {
          // TODO
          // put together a fit statement with correct max width and height
          // let { crop, x, y, z } = get(data, 'settings') || {};
        }

        image = {
          src: `${storageRoute}/images/${data.id}/${data.source.name}?${fit}`,
          error: `${storageRoute}/images/${data.id}/${data.source.name}?${fit}&preview=greyscale`,
          loading: `${storageRoute}/images/${data.id}/${data.source.name}?${fit}&preview=blur`,
          width: w,
          height: h,
          aspectRatio
        };
      }

      return image;
    },
    style() {
      let style;
      if (this.display === 'tile' && this.teaser.style) {
        style = {
          position: 'absolute',
          display: 'flex',
          left: `${this.teaser.style.left}px`,
          top: `${this.teaser.style.top}px`,
          width: `${this.teaser.style.width}px`,
          height: `${this.teaser.style.height}px`
        };
      }
      return style;
    },
    clamp() {
      let clamp = 3;
      if (this.ratings && this.ratings.length) clamp = 2;
      return clamp;
    },
    ...mapGetters({
      customer: 'shop/customer',
      defaultCustomerGroup: 'shop/defaultCustomerGroup',
      // defaultTax: 'shop/defaultTax',
      cms: 'CMS'
    })
  },
  methods: {
    hover() {
      this.$emit('focus', this.item);
      this.mouseover = true;
    },
    blur() {
      setTimeout(() => {
        this.$emit('blur', this.item);
        this.mouseover = false;
      }, this.delay);
    },
    striptags(html) {
      html = html.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />');
      return striptags(html, ['a', 'i', 'u', 'b', 'em', 'strong', 'span', 'br']);
    },
    preloadImage() {
      let img = new Image();
      img.onload = () => {
        this.loaded = true;
        setTimeout(() => (this.loading = false), 10);
      };
      img.onerror = () => {
        this.error = true;
        setTimeout(() => (this.loading = false), 10);
      };
      img.src = this.image.src;
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.image?.src) this.preloadImage();
    }, 1);

    if (this.display === 'tile') {
      // VanillaTilt.init(this.$refs.container, {
      //   scale: 1.02,
      //   speed: 300,
      //   perspective: 6000,
      //   max: 5,
      //   glare: true,
      //   'max-glare': 0.5
      // });
    }
  }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

.card-teaser, .tile-teaser
  background-color: $white
  width: 100%
  &:after
    content: ''
    position: absolute
    top: 0
    left: 0
    height: 100%
    width: 100%
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)
    z-index: -1
    transform: translateZ(-50px)
    transition: .3s
  .placeholder
    padding-bottom: 100%
    position: relative
    svg
      width: 100%
      height: 100%
      position: absolute
      top: 0
      left: 0
      line
        stroke: rgba($red, .3)
        stroke-width: 1.02
  figure
    padding: 15px
    display: flex
    width: 100%
    justify-content: center
    align-items: center
    height: 300px
    img
      max-width: 100%
      max-height: 100%
      // &[lazy="loaded"]
      //   width: initial !important
      //   height: initial !important
  .info
    // height: 135px
    overflow-x: hidden
    width: 100%
    .name, .description
      line-height: 1.3
      word-break: normal !important
    .price
      margin-top: auto

.card-teaser
  transition: transform .3s ease
  .description,
  .properties
    margin-top: 0.5rem
  figure
    position: relative
    img
      z-index: 1
    .background
      opacity: 0
      z-index: 0
      background-size: cover
      // background-attachment: fixed
      position: absolute
      left: 0
      top: 0
      width: 100%
      height: 100%
      transition: opacity .3s ease
    img[lazy="loaded"] + .background
      // NOTE: opacity: 1 --> blurry background
      opacity: 0
      // &:before
      //   content: ''
      //   position: absolute
      //   left: 0
      //   top: 0
      //   width: 100%
      //   height: 100%
      //   background-color: rgba(0, 0, 0, .3)
  // .info
  //   min-height: 120px

.tile-teaser
  .placeholder
    height: calc(100% - 60px)
  .info
    overflow: hidden
    background-color: $white
    width: 100%
    height: auto
    position: absolute
    bottom: 0
    .price
      margin-top: initial
    .properties
      margin-top: 0.5rem
    .content
      margin-top: 0.5rem
      &::v-deep
        br + br
          display: none

.product-teaser
  // transform-style: preserve-3d
  will-change: transform
  // .name, .description, .price
  //   transform: translateZ(50px) scale(1)

a:hover
  z-index: 2
  position: relative
  .tile-teaser, .card-teaser
    &:after
      box-shadow: 0 10px 50px -10px rgba(0, 0, 0, 0.2), 0 40px 80px 0 rgba(0, 0, 0, 0.05)
  .card-teaser
    transform: scale(1.02)

// all cards same height
.horizontal .product-teaser
    min-height: 100%
    display: flex

    .card-teaser
        grid-template-rows: max-content auto

.strikethrough
  font-size: 0.8em
  opacity: 0.6
  color: $black
  &:before
    border-color: theme('colors.gray.700')

.price
  position: relative
.price nobr + nobr.sale
  margin-left: 1rem
  color: theme('colors.red.600')
  position: relative
  font-weight: bold
  z-index: 1
  // &:before
  //   content: ''
  //   position: absolute
  //   // background-color: theme('colors.red.100')
  //   background-color: #e6ff15
  //   width: calc(100% + 8px)
  //   height: calc(100% + 4px)
  //   left: -4px
  //   top: -7px
  //   z-index: -1
  //   transform: rotate(-9deg) skew(-2deg, 0deg)
</style>
